import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Table, Input, Button, Space, Tooltip, InputNumber, Form, Typography, Popconfirm } from 'antd';
import Highlighter from 'react-highlight-words';
import { SearchOutlined, LoadingOutlined } from '@ant-design/icons';
import { encode } from 'js-base64';

const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
}) => {
    const inputNode = inputType === 'number' ? <InputNumber style={{ width: "100%" }} /> : <Input />;
    return (
        <td {...restProps}>
            {editing ? (
                <Form.Item
                    name={dataIndex}
                    style={{
                        margin: 0,
                    }}
                    rules={[
                        {
                            required: true,
                            message: `Please Input ${title}!`,
                        },
                    ]}
                >
                    {inputNode}
                </Form.Item>
            ) : (
                children
            )}
        </td>
    );
};

export default function DetailTable({ data, loading}) {

    const Bucket = "https://d1e9ilirjteg2w.cloudfront.net/";

    var searchInput;

    const [form] = Form.useForm();
    const [editingKey, setEditingKey] = useState('');

    const isEditing = (record) => record.key === editingKey;

    const [state, setState] = useState({
        searchText: '',
        searchedColumn: '',
    });


    const getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        searchInput = node;
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        // size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button onClick={() => handleReset(clearFilters)} style={{ width: 90 }}>
                        Reset
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
                : '',
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => searchInput.select(), 100);
            }
        },
        render: text =>
            state.searchedColumn === dataIndex ? (
                <Tooltip placement="topLeft" title={
                    <Highlighter
                        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                        searchWords={[state.searchText]}
                        autoEscape
                        textToHighlight={text ? text.toString() : ''}
                    />
                }>
                    <Highlighter
                        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                        searchWords={[state.searchText]}
                        autoEscape
                        textToHighlight={text ? text.toString() : ''}
                    />
                </Tooltip>
            ) : (
                <Tooltip placement="topLeft" title={text}>{text}</Tooltip>
            ),
    });

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    };

    const handleReset = clearFilters => {
        clearFilters();
        setState({ searchText: '' });
    };

    console.log(data);

    const columns = [
        {
            title: 'Reaction ID',
            dataIndex: 'Reaction_id',
            key: 'Reaction_id',
            width: 150,
            editable: false,
            sorter: (a, b) => a.Reaction_id.localeCompare(b.Reaction_id),
            ellipsis: {
                showTitle: false,
            },
            ...getColumnSearchProps('Reaction_id'),
        },
        {
            title: 'Equation(ID)',
            dataIndex: 'Equation(ID)',
            key: 'Equation(ID)',
            width: 250,
            editable: true,
            sorter: (a, b) => a["Equation(ID)"].localeCompare(b["Equation(ID)"]),
            ellipsis: {
                showTitle: false,
            },
            ...getColumnSearchProps('Equation(ID)'),
        },
        
        {
            title: 'Formula',
            dataIndex: 'Formula',
            key: 'Formula',
            width: 150,
            editable: false,
            sorter: (a, b) => a["Formula"].localeCompare(b["Formula"]),
            ellipsis: {
                showTitle: false,
            },
            ...getColumnSearchProps('Formula'),
        },
        {
            title: 'Original',
            dataIndex: 'Original',
            key: 'Original',
            width: 200,
            editable: false,
            // sorter: (a, b) => a["Original"].localeCompare(b["Original"]),
            ellipsis: {
                showTitle: false,
            },
            ...getColumnSearchProps('Original'),
            // render:(_,record)=>{
            //     return(<>{JSON.stringify(record.Original)}</>)
            // }
        },
        {
            title: 'L_b',
            dataIndex: 'L_b',
            key: 'L_b',
            width: 100,
            editable: true,
            sorter: (a, b) => a["L_b"] - b["L_b"],
            ellipsis: {
                showTitle: false,
            },
            ...getColumnSearchProps('L_b'),
        },
        {
            title: 'U_b',
            dataIndex: 'U_b',
            key: 'U_b',
            width: 100,
            editable: true,
            sorter: (a, b) => a["U_b"] - b["U_b"],
            ellipsis: {
                showTitle: false,
            },
            ...getColumnSearchProps('U_b'),
        }
    ];

    return (
        <>
        <Form form={form} component={false}>
            {/* <div style={{ overflow:"auto"}}> */}
            <Table
                // bordered
                id="antdTable1"
                rowKey="Reaction_id"
                columns={columns}
                dataSource={data}
                loading={loading}
                pagination={ data.length > 10 ? true : false}
                scroll={{x:1100}}
            />
            {/* </div> */}
            </Form>

        </>

    );
    // }
}
